const BASE_MENU_URL = '/v2/menu';

export const getUrlForItemDetailPageFromSlug = (slug: string) => {
  return `${BASE_MENU_URL}/${slug}`;
};
